<template>
  <div class="topHeader">
    <ul class="mainNav">
      <li v-for="(item,index) in navList"  :class="{'isActive':activeName==index}" :key="index" @click.stop="handleClick(index)">{{item}}</li>
    </ul>
     <!-- <div v-if="activeName===0" class="contain">
      <project-team ref="allperson"></project-team>
    </div>
    <div v-else-if="activeName===1" class="contain">
       <interior></interior>
    </div> -->
    <div v-if="activeName===0" class="contain">
       <external></external>
    </div>
  </div>
</template>

<script>
import interior from './interior/interior'
import external from './external/external'
import projectTeam from '@/views/project/home/projectTeam.vue'
export default {
  name:'prjMember',

  data () {
    return {
      activeName:0, //interior 内部 external 外部 allperson全部
      navList: ["成员"],
    }
  },

  components : {
    interior,
    external,
    projectTeam
  },

  methods : {
    handleClick (index) { 
      this.activeName=index;
      
    }
  }
}
</script>

<style lang="scss"  scoped>
.topHeader{
  width: 100%;
  height: 100%;
  .mainNav{
    width: 100%;
    height: 50px;
    display: flex;
    box-sizing: border-box;
    align-items: center;
    font-size: 16px;
    background-color: #fff;
    padding-left: 27px;
    li{
      box-sizing: border-box;
      cursor: pointer;
      margin-right: 10px;
      font-size: 16px;
      user-select: none;
      text-align: center;
      color: #999999;
      line-height: 32px;
      margin-right: 27px;
    }
    .isActive{
      color: #5584FF;
      border-bottom: 2px solid #5587F0;
    }
  }
  .contain{
    height:calc(100% - 64px)
  }
}
</style>
 